<template>
  <div :id="$id('auswahl-werte')">
    <b-container fluid>
      <!--            class="top-buffer"-->
      <div v-if="attribut.auswahlWerte.length < 7 || attribut.eingabeWerte.length !== 0">
        <b-row  v-for="(auswahlWert, index) in attribut.auswahlWerte" v-bind:key="auswahlWert.id">
          <b-col sm="10" class="padding-0">
            <div class="custom-control custom-radio">
              <input type="radio" ref="radioButtons" class="custom-control-input"
                     :id="$id('radio-auswahl-wert' + index)" :name="groupName"
                     :disabled="auswahlWert.disabled" :value="auswahlWert"
                     v-model="selectedAuswahlWert" @change="triggerVorzugswertReminder(auswahlWert, attribut.auswahlWerte.concat(attribut.eingabeWerte))"/>
              <label class="custom-control-label" :for="$id('radio-auswahl-wert' + index)"
                     :style="(selectedAuswahlWert !=null && selectedAuswahlWert.name===auswahlWert.name)? 'font-weight:500' : ''">
                {{ auswahlWert.i18NName }}
                <Vorzugswert :vorzugswert="auswahlWert.vorzugswert" class="padding-left"/>
                <I18NImage :i18-n-pic-id="auswahlWert.i18NPictureId" :pic-title="auswahlWert.i18NName" :i18-n-description="auswahlWert.i18NDescription"/>
              </label>
            </div>
          </b-col>
        </b-row>
      </div>
      <div v-else style="position: relative">
        <b-row class="top-buffer">
          <b-col sm="12" class="padding-0">

            <b-dropdown variant="outline-secondary" boundary="viewport" class="mayr-btn-dropdown-auswahlwert">

              <template v-slot:button-content>
                <div v-if="selectedAuswahlWert" class="mayr-btn-dropdown-auswahlwert-content">{{selectedAuswahlWert.name}} <Vorzugswert :vorzugswert="selectedAuswahlWert.vorzugswert" class="padding-left" /></div>
                <div v-else class="mayr-btn-dropdown-auswahlwert-content">{{ $t('produktmerkmale-overview.plsSelect')}} </div>
              </template>

              <b-dropdown-item-button v-for="(auswahlWert) in attribut.auswahlWerte" v-bind:key="auswahlWert.id"
                                      v-on:click="onDropdwonClick(auswahlWert, attribut.auswahlWerte)" :disabled="auswahlWert.disabled" style="font-size: 14px">
                {{auswahlWert.name}}
                <Vorzugswert :vorzugswert="auswahlWert.vorzugswert" class="padding-left" />
              </b-dropdown-item-button>
            </b-dropdown>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
import Vorzugswert from "@/components/config-page/utils/Vorzugswert";
import I18NImage from "@/components/config-page/utils/I18NImage";

export default {
  name: 'AuswahlWerte',
  components: {Vorzugswert, I18NImage},
  props: ['attribut', 'groupName', 'gruppenName'],
  computed: {
    selectedAuswahlWert: {
      get() {
        return this.attribut.selectedAuswahlWert;
      },
      set(value) {
        let attribut = this.attribut;
        this.$store.commit('setSelectedAuswahlWert', {attribut: attribut, value: value})
      }
    }
  },
  methods: {
    onDropdwonClick(auswahlWert, werte) {
      this.triggerVorzugswertReminder(auswahlWert, werte)
      this.selectedAuswahlWert = auswahlWert;
    },
    triggerVorzugswertReminder(wert, werte) {
      // var array = this.attribut.auswahlWerte.concat(this.attribut.eingabeWerte)
      for (let i = 0; i < werte.length; i++) {
        if (werte[i].vorzugswert && !wert.vorzugswert) {
          this.$store.commit('setNotificationContent', {variant: 'warning', title: this.$i18n.t('vorzugswert.alertTitle'), text: this.$i18n.t('vorzugswert.alertText'), dontHide: false});
          this.$store.commit('showNotification');
          return
        }
      }
    }
  }
}
</script>

<style scoped>
.top-buffer {
  margin-top: 7px
}

.padding-0 {
  padding-right: 0;
  padding-left: 1px;
}

.padding-left {
  padding-left: 5px;
}
</style>